<div fxLayoutAlign="center center" fxFlexFill class="main-div">
  <form [formGroup]="registerForm" (submit)="createUser()">
    <mat-card fxFlex="25">
      <p>Adaugă un agent nou</p>
      <div fxLayoutAlign="stretch" fxLayout="column" class="register-form">
        <mat-form-field appearance="outline">
          <input
            matInput
            class="custom-input"
            type="text"
            placeholder="Nume"
            formControlName="firstName"
          />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <input
            matInput
            class="custom-input"
            type="text"
            placeholder="Prenume"
            formControlName="lastName"
          />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <input
            matInput
            class="custom-input"
            type="email"
            placeholder="Adresă de e-mail"
            formControlName="email"
          />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <input
            matInput
            [type]="visibilityMapping.password ? 'text' : 'password'"
            class="custom-input"
            placeholder="Parolă"
            formControlName="password"
          />
          <button
            type="button"
            class="hide-btn"
            (click)="viewPassword('password')"
          >
            <i
              class="eye-icon"
              [ngClass]="
                visibilityMapping.password ? 'bi bi-eye' : 'bi bi-eye-slash'
              "
            ></i>
          </button>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <input
            matInput
            [type]="visibilityMapping.confirmPassword ? 'text' : 'password'"
            class="custom-input"
            placeholder="Confirmă parola"
            formControlName="confirmPassword"
          />
          <button
            type="button"
            class="hide-btn"
            (click)="viewPassword('confirmPassword')"
          >
            <i
              class="eye-icon"
              [ngClass]="
                visibilityMapping.confirmPassword
                  ? 'bi bi-eye'
                  : 'bi bi-eye-slash'
              "
            ></i>
          </button>
        </mat-form-field>
        <button class="register-button" type="submit">Creează cont</button>
      </div>
    </mat-card>
  </form>
</div>
